import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionMembresia";
import {
  GetMembresiaTracking,
  PostMembresiaTracking
} from "../../../reducers/comisionMembresia";
import MembresiaTrackingClub from "../../../../types/MembresiaTrackingClub";

export interface TrackingClubesDispatcher {
  getTrackingByPeriodo: (
    periodo: string
  ) => Promise<Preview<GetMembresiaTracking>>;
  postTracking: (
    trackingList: MembresiaTrackingClub[]
  ) => Promise<Preview<PostMembresiaTracking>>;
  clearTracking: () => void;
}

export const trackingClubesDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TrackingClubesDispatcher = dispatch => ({
  getTrackingByPeriodo: (periodo: string) => {
    return dispatch(actions.getTrackingByPeriodo(periodo));
  },
  postTracking: (trackingList: MembresiaTrackingClub[]) => {
    return dispatch(actions.postTracking(trackingList));
  },
  clearTracking: () => {
    return dispatch(actions.clearTracking());
  }
});
